import { loadStripe } from '@stripe/stripe-js/pure'
import type { Stripe } from '@stripe/stripe-js'

const stripeCache = new Map<string, Promise<Stripe | null>>()

export function getStripe(publishableKey: string): Promise<Stripe | null> {
  const cached = stripeCache.get(publishableKey)
  if (cached) return cached
  const promise = loadStripe(publishableKey)
  stripeCache.set(publishableKey, promise)
  return promise
}
